module.exports = __webpack_public_path__ + "d45e2277e7fe2d3fafd824241e316f15.jpg";